import { Col, Row } from 'react-styled-flexboxgrid';

import InvertedCta from './ui/buttons/InvertedCta';
import ResponsiveGrid from './ui/ResponsiveGrid';
import SectionHeadline from './ui/elements/SectionHeadline';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Container = styled.section`
  z-index: 99;
  position: relative;
  max-width: 100vw;
  min-height: 25rem;
  text-align: center;
  background: linear-gradient(180deg, ${theme('colors.lightOrange')} 0%, ${theme('colors.orange')} 100%);
`;

const MainRow = styled(Row)`
  position: relative;
  min-height: 25rem;
`;

const Heading = styled(SectionHeadline)`
  text-align: center;
  color: ${theme('colors.white')};
  font-weight: normal;
  margin: 0 0 2rem 0;
`;

const Subheading = styled(SectionHeadline)`
  text-align: center;
  color: ${theme('colors.white')};
  margin: 0 0 3rem 0;
`;

const CtaSection = ({ bottomCta }) => {
  if (!bottomCta) {
    return null;
  }

  const { heading, subheading, ctaText, ctaUrl } = bottomCta;

  return (
    <Container>
      <ResponsiveGrid>
        <MainRow center="xs" middle="xs">
          <Col xs={12} sm={12}>
            <Heading as="h4" xs={28} sm={28} md={28} lg={28}>
              {heading}
            </Heading>
            <Subheading as="h3" xs={32} sm={36} md={36} lg={36}>
              {subheading}
            </Subheading>
            <InvertedCta to={ctaUrl}>{ctaText}</InvertedCta>
          </Col>
        </MainRow>
      </ResponsiveGrid>
    </Container>
  );
};

export default CtaSection;
